/*eslint perfectionist/sort-objects: "error"*/

export const enGb = {
  account: "Account",
  accountHolderName: "Account holder name",
  accountId: "Account ID",
  accountNumber: "Account number",
  aliasAccountNumber: "Alias account number",
  aliasIban: "Alias IBAN",
  aliasSortCode: "Alias sort code",
  aliasSwiftCodeBic: "Alias swift code (BIC)",
  amount: "Amount",
  amountDisabledBlocked:
    "Amount can't be set - this payment can't be refunded right now.",
  amountDisabledError:
    "Amount can't be set - couldn't check refund eligibility.",
  amountDisabledFullyRefunded:
    "Amount can't be set - no balance available to refund.",
  amountDisabledWindowClosed:
    "Amount can't be set - time for refund has expired.",
  amountRefundedAlready: "Amount refunded already",
  approve: "Approve",
  approved: "Approved",
  approvingTransaction: "Approving transaction",
  areYouSureYouWantToRejectThisPayment:
    "Are you sure you want to reject this payment?",
  availableToRefund: "Available to refund",
  availableToRefundAmount: "Available to refund: {{amount}}.",
  availableToRefundFetchError: "Couldn't check refund eligibility.",
  backToAllPayments: "Back to all payments",
  beneficiary: "Beneficiary",
  bounceBack: "Bounce back",
  choosingPayment: "Choosing payment",
  closedLoopPayout: "Payout — closed loop",
  closedLoopPayoutDescription:
    "Send funds to a customer who paid in the last 12 months",
  comingSoon: "Coming soon",
  completed: "Completed",
  country: "Country",
  created: "Created",
  createdBy: "Created by",
  createdByName: "Created by {{name}}",
  createdByScheduler: "Created by scheduler",
  createdViaApi: "Created via API",
  createPayment: "Create payment",
  createPaymentFailure: "We couldn't create this payment. Please try again.",
  credit: "Credit",
  details: "Details",
  findPaymentToRefund: "Find a payment that you want to refund.",
  gatewayPayment: "Gateway payment",
  givenSourceAccountCouldNotBeFound:
    "The account you're trying to use could not be found.",
  iban: "IBAN",
  incoming: "Incoming",
  internal: "Internal",
  internalFx: "Internal FX",
  internalFxDescription: "Internal transfer with currency conversion",
  internalReference: "Internal reference",
  internalTransfer: "Internal transfer",
  internalTransferDescription: "Transfer funds between accounts within Volt",
  local: "Local",
  name: "Name",
  newPayment: "New payment",
  noPayments: "No payments",
  openLoopPayout: "Payout — open loop",
  openLoopPayoutDescription: "Make a one-time transfer to a new beneficiary",
  outgoing: "Outgoing",
  own: "Own",
  owner: "Owner",
  payment: "Payment",
  paymentAmount: "Payment amount",
  paymentHasBeenApproved: "Payment has been approved",
  paymentHasBeenRejected: "Payment has been rejected",
  paymentRail: "Payment rail",
  paymentReference: "Payment reference",
  payments: "Payments",
  paymentType: "Payment type",
  paymentTypeDescription: "Pick what you want to do with this account.",
  payout: "Payout",
  processing: "Processing",
  reference: "Reference",
  refund: "Refund",
  refundAlreadyInProgress: "A refund is already in progress for this payment.",
  refundDescription: "Refund an existing payment",
  refundDueDate: "Refund due date",
  refundFullyRefunded: "This payment has already been fully refunded.",
  refundFundsAlreadyReturned: "This payment has already been refunded.",
  refundsRequested: "Refunds requested",
  refundTransactionAccountNotMatched:
    "This payment doesn't belong to the selected account.",
  refundWindowClosed: "The refund window for this payment closed on {{date}}.",
  reject: "Reject",
  rejected: "Rejected",
  rejectingPayment: "Rejecting payment",
  scaRequiredToApproveThisPayment:
    "You need to set up strong customer authentication (SCA) to approve this payment",
  sender: "Sender",
  sepaInstant: "SEPA Instant",
  setMaxAmount: "Set max amount",
  settlement: "Settlement",
  settlementDescription: "Settle funds to a trusted beneficiary",
  sortCode: "Sort code",
  source: "Source",
  sourceAccount: "Source account",
  sourceAccountDescription:
    "Search by name or paste an exact IBAN / account number.",
  sourceAccountNotFound: "Account not found",
  sourceAccountPlaceholder: "Select account",
  sourcePaymentNotFound: "Payment not found",
  status: "Status",
  swiftCodeBic: "Swift code (BIC)",
  topUp: "Top-up",
  type: "Type",
  uniqueReference: "Unique reference",
  unknownUser: "User",
  voltId: "Volt ID",
  voltIsVerifyingPayeeDetails:
    "Volt is verifying payee details. Approval will be available once verification is complete.",
  voltPaymentId: "Volt payment ID",
  youCannotPerformThisOperation: "You cannot perform this operation",
  youDontHaveAnyPaymentsThatMatchTheCriteria:
    "You don't have any payments that match the criteria.",
  youDontHaveAnyPaymentsYet: "You don't have any payments yet.",
};
